import { useTranslation } from 'react-i18next';
import { useAppSettingsStore, useMediaQuery } from '@/shared/lib';
import {
  ACCOUNT_TYPE_LABEL_KEYS,
  TradingAssetActionMenu,
  TradingAssetAmount,
  useTradingAssetActions,
} from '@/widgets/trading-assets';
import type { TradingSearchGroup } from '../../model';
import {
  SEARCH_ACTION_TRIGGER_CLASSNAME,
  SEARCH_SUBMENU_CLASSNAME,
} from '../../config/styles';
import { SearchCell } from './SearchCell';
import { SearchGroupTitle } from './SearchGroupTitle';

type Props = {
  groups: Array<TradingSearchGroup>;
  baseCode: string;
  withTitle?: boolean;
  onActionRun: () => void;
};

const SearchTradingGroups = ({
  groups,
  baseCode,
  withTitle = true,
  onActionRun,
}: Props) => {
  const { t } = useTranslation();
  const { isBalancesHidden } = useAppSettingsStore();
  const isTabletUp = useMediaQuery('(min-width: 1068px)');
  const { getActionsVisibility, onTrade, onTransfer } =
    useTradingAssetActions();

  if (groups.length === 0) {
    return null;
  }

  return (
    <>
      {groups.map(group => (
        <div key={group.type} className="flex flex-col">
          {withTitle && (
            <SearchGroupTitle>
              {t(ACCOUNT_TYPE_LABEL_KEYS[group.type])}
            </SearchGroupTitle>
          )}

          <div className="flex flex-col">
            {group.rows.map(row => (
              <SearchCell
                key={`${group.type}-${row.code}`}
                code={row.code}
                name={row.name}
                icon={row.icon}
                amount={
                  <>
                    <TradingAssetAmount
                      isBalancesHidden={isBalancesHidden}
                      valueText={row.amountText}
                      suffix={row.code}
                    />
                    <TradingAssetAmount
                      isBalancesHidden={isBalancesHidden}
                      valueText={row.baseAmountText}
                      suffix={baseCode}
                      valueClassName="p6 text-secondary"
                    />
                  </>
                }
                action={
                  <TradingAssetActionMenu
                    row={row}
                    visibility={getActionsVisibility(row)}
                    contentClassName="dark"
                    triggerClassName={SEARCH_ACTION_TRIGGER_CLASSNAME}
                    submenuClassName={SEARCH_SUBMENU_CLASSNAME}
                    submenuAside={isTabletUp}
                    onTrade={(r, account) => {
                      onActionRun();
                      onTrade(r, account);
                    }}
                    onTransfer={(r, account) => {
                      onActionRun();
                      onTransfer(r, account);
                    }}
                  />
                }
              />
            ))}
          </div>
        </div>
      ))}
    </>
  );
};

export { SearchTradingGroups };
